/**
 * Klucz cache stanu waluty kont Stripe. Osobny plik, żeby mutacje płatności punktów
 * i waluty hotelu mogły go unieważniać bez cyklu importów z hookiem monitu.
 */
export const STRIPE_CURRENCY_STATUS_QUERY_KEY = 'stripe-currency-status';
